import type { TrayState } from '../../game/boardMVC/types';
import { TileStackModel } from '../../game/boardMVC/models/board/TileStackModel';
import { TileModel } from '../../game/boardMVC/models/board/TileModel';
import { TRAY_STACKS } from '../constants';

export class EditorTrayModel {
  private readonly stacks: TileStackModel[];

  constructor(state?: TrayState) {
    this.stacks = this.initStacks(state);
  }

  private initStacks(state?: TrayState): TileStackModel[] {
    const stackColors = state?.colors.slice() ?? [];
    while (stackColors.length < TRAY_STACKS) stackColors.push([]);
    return stackColors.map((colors) => new TileStackModel(0, 0).addTiles(colors.map((color) => new TileModel(color))));
  }

  public getStacks(): TileStackModel[] {
    return this.stacks.slice();
  }

  public exportState(): TrayState {
    const colors = this.stacks.map((stack) => stack.exportState().tiles);
    while (colors.length > 0 && colors[colors.length - 1].length === 0) {
      colors.pop(); // prune empty colors at the end of the list.
    }
    return { colors };
  }
}
